import { styled } from '@mui/material/styles';
import WdPageSimple from '@main/core/WdPageSimple/WdPageSimple';
import { useContext, useEffect, useState } from 'react';
import { ComposedHeader, FormCardLayout, TextWithLabel } from '@main/components';
import { getDataBilliong } from 'src/app/api/company';
import { useRequest } from '@main/hooks';
import { useSearchParams } from 'react-router-dom';
import { Box, Divider, Grid, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/core/messageSlice';
import { BootstrapContext } from 'app/bootstrap/BootstrapContext';

const Root = styled(WdPageSimple)(({ theme }) => ({
  backgroundColor: '#FFF',
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

export const InfoBilling = () => {
  const Dispatch = useDispatch();

  const { finalizeSession } = useContext(BootstrapContext);
  const [searchParams] = useSearchParams();
  const previousId = searchParams.get('id');
  const [data, setData] = useState({});

  const handleOnForbidden = async () => {
    await finalizeSession();
  };

  const handleOnError = async (message) => {
    Dispatch(showMessage({ message }));
  };
  const {
    makeRequest: tryGetCompany,
    response: responseGetCompany,
    isLoading: isLoadingGetCompany,
  } = useRequest(getDataBilliong, {
    onForbidden: handleOnForbidden,
    onError: handleOnError,
  });

  useEffect(() => {
    if (previousId === undefined) return;
    tryGetCompany(previousId);
    console.log('Id facturacion: ', previousId);
  }, [previousId]);

  useEffect(() => {
    if (responseGetCompany === undefined) return;
    setData(responseGetCompany);
    console.log('Contenido de la respuesta', responseGetCompany);
  }, [responseGetCompany]);

  const test = 'test 01';

  return (
    <Root
      header={
        <ComposedHeader
          decorator="button"
          title={`Datos de facturación: ${test}`}
          description="Información datos de facturación"
        />
      }
      content={
        <Box
          className="flex justify-center items-start"
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <FormCardLayout maxWidth="120rem">
            <Grid container spacing={2} className="mx-32">
              <Grid item xs={12} md={5}>
                <Box sx={{ flex: 1 }}>
                  <div className="my-16">
                    <Typography className="text-2xl font-light">Datos de contacto</Typography>
                  </div>
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Nombre responsable">
                    {data?.p ?? 'Juanito Pérez'}
                  </TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Correo eléctronico">
                    {data?.p ?? 'email.gmail.com'}
                  </TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Teléfono">{data?.p ?? '545646465456'}</TextWithLabel>
                  {/* )} */}
                </Box>

                <Divider />

                <Box sx={{ flex: 1 }}>
                  <div className="my-16">
                    <Typography className="text-2xl font-light">Datos fiscales</Typography>
                  </div>
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Régimen fiscal">{data?.p ?? 'simplificada'}</TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="RFC">{data?.p ?? 'AOHU870798N91'}</TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Razón social">{data?.p ?? 'Juan Pérez SA'}</TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Uso de CFDI">{data?.p ?? 'General'}</TextWithLabel>
                  {/* )} */}
                  {/* {data?.p && ( */}
                  <TextWithLabel title="Método de pago">
                    {data?.p ?? 'Tarjeta crédito'}
                  </TextWithLabel>
                  {/* )} */}
                </Box>
              </Grid>
              <Grid item xs={12} md={1} className="flex justify-center items-center">
                <Divider orientation="vertical" flexItem />
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="my-16">
                  <Typography className="text-2xl font-light">Domicilio fiscal</Typography>
                </div>
                {/* {data?.p && ( */}
                <TextWithLabel title="Calle">{data?.p ?? 'Paseo de la Reforma'}</TextWithLabel>
                {/* )} */}
                {data?.p && <TextWithLabel title="No. Exterior">{data?.p ?? '223'}</TextWithLabel>}
                {data?.p && <TextWithLabel title="No. Interior">{data?.p ?? '4B'}</TextWithLabel>}
                {/* {data?.p && ( */}
                <TextWithLabel title="Colonia">{data?.p ?? 'Reforma Norte'}</TextWithLabel>
                {/* )} */}
                {/* {data?.p && ( */}
                <TextWithLabel title="Alcaldía o Municipio">
                  {data?.p ?? 'Gustavo A Madero'}
                </TextWithLabel>
                {/* )} */}
                {/* {data?.p && ( */}
                <TextWithLabel title="Estado">{data?.p ?? 'Estado de México'}</TextWithLabel>
                {/* )} */}
                {/* {data?.p && ( */}
                <TextWithLabel title="Código postal">{data?.p ?? '54120'}</TextWithLabel>
                {/* )} */}
                {data?.p && <TextWithLabel title="País">{data?.p ?? 'México'}</TextWithLabel>}
              </Grid>
            </Grid>
          </FormCardLayout>
        </Box>
      }
    />
  );
};
